import { ChartNoAxesCombined } from "lucide-react";
import { FormattedMessage } from "react-intl";

import { PageIntro } from "@/components/common";

export default function InsightsPage() {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-6 py-10 lg:px-10">
      <PageIntro title={<FormattedMessage id="insights.title" defaultMessage="Insights" />} />

      <section className="flex min-h-72 items-center justify-center rounded-2xl border border-border bg-card px-6 py-14 text-center">
        <div className="flex max-w-xl flex-col items-center gap-5">
          <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-foreground text-brand">
            <ChartNoAxesCombined className="h-6 w-6" strokeWidth={2.1} />
          </span>
          <div className="space-y-3">
            <h2 className="text-xl font-bold tracking-tight text-foreground">
              <FormattedMessage
                id="insights.comingSoonTitle"
                defaultMessage="Insights — coming soon"
              />
            </h2>
            <p className="text-sm leading-6 text-muted-foreground">
              <FormattedMessage
                id="insights.comingSoonDescription"
                defaultMessage="Performance dashboards across every channel — reach, engagement, conversions, and what to do next. We're stitching it together right now."
              />
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
